import React from "react";
import PropTypes from "prop-types";
import { FaCheckCircle, FaClock } from "react-icons/fa";
import "./PhaseCard.css";

const PhaseCard = ({ phase, mode, onClick }) => {
    const isAvailable = phase.isActive;
    const isSell = mode === "sell";

    return (
        <div
            className={`phase-card ${isAvailable ? "available" : "coming-soon"} ${
                isSell ? "sell-mode" : "buy-mode"
            }`}
            onClick={isAvailable ? onClick : undefined}
            role={isAvailable ? "button" : undefined}
            tabIndex={isAvailable ? 0 : undefined}
        >
            <div className="phase-status">
                {isAvailable ? (
                    <FaCheckCircle className="status-icon available-icon" />
                ) : (
                    <FaClock className="status-icon coming-soon-icon" />
                )}
            </div>

            <div className="phase-info">
                <span className="phase-name">{phase.name}</span>
                <span className="phase-price">${phase.priceFormatted}/MCGP</span>
            </div>

            <div className="phase-badge">
                {isAvailable ? (
                    <span className="badge-available">Available</span>
                ) : (
                    <span className="badge-coming-soon">Coming Soon</span>
                )}
            </div>
        </div>
    );
};

PhaseCard.propTypes = {
    phase: PropTypes.shape({
        isActive: PropTypes.bool,
        name: PropTypes.string,
        priceFormatted: PropTypes.string,
    }).isRequired,
    mode: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export default PhaseCard;
